import fetcher from '@api/fetchers';
import { CBT_RESERVE_FLOW } from '@cont/SeeAll/constants';
import {
  getCbtCentresAPIKey,
  getCbtLocationsAPIKey,
  getCbtReserveAPIKey
} from '@cont/SeeAll/utils';

export const fetchCbtLocations = (programmeUid) =>
  fetcher(getCbtLocationsAPIKey(programmeUid), { useCamelCase: false });

export const fetchCbtCentres = (programmeUid, city) =>
  fetcher(getCbtCentresAPIKey(programmeUid, city));

export const reserveCbtSeat = (programmeUid, selection) =>
  fetcher(getCbtReserveAPIKey(), {
    requestType: 'POST',
    body: {
      centre_uid: selection.centreUid,
      user_id: selection.userId,
      name: selection.fullName,
      email: selection.email,
      programme_uid: programmeUid,
      flow: CBT_RESERVE_FLOW.STORE
    }
  });

export const reserveCbtSeatForCombo = (programmeUid, selection) =>
  fetcher(getCbtReserveAPIKey(), {
    requestType: 'POST',
    body: {
      centre_uid: selection.centreUid,
      user_id: selection.userId,
      name: selection.fullName,
      email: selection.email,
      programme_uid: programmeUid,
      flow: CBT_RESERVE_FLOW.COMBO
    }
  });

export const reserveCbtSeatForBundle = (cbtGoalUid, selection) =>
  fetcher(getCbtReserveAPIKey(), {
    requestType: 'POST',
    body: {
      centre_uid: selection.centreUid,
      user_id: selection.userId,
      name: selection.fullName,
      email: selection.email,
      cbt_goal_uid: cbtGoalUid,
      flow: CBT_RESERVE_FLOW.BUNDLE
    }
  });
